/** @format */

import angular from 'angular';
import angularSanitize from 'angular-sanitize';
import angularTranslate from 'angular-translate';

import { I18nModule as ccJsI18nModule } from 'crowdcomms-js/lib/i18n';
import { ErrorsModule } from 'crowdcomms-js/lib/galabid/errors';
import { FormatModule } from 'crowdcomms-js/lib/galabid/format';

import { I18nConfig } from './i18n.config.js';

export const I18nModule = angular
    .module('galabid-presenter.shared.i18n', [
        angularSanitize,
        angularTranslate,
        ccJsI18nModule,
        ErrorsModule,
        FormatModule,
    ])
    .config(I18nConfig).name;
